import { render } from "./ActivityDetailed.vue?vue&type=template&id=08ae9ae2&scoped=true"
import script from "./ActivityDetailed.vue?vue&type=script&lang=js"
export * from "./ActivityDetailed.vue?vue&type=script&lang=js"

import "./ActivityDetailed.vue?vue&type=style&index=0&id=08ae9ae2&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ae9ae2"]])

export default __exports__